import React from "react";
import Button from "../../assets/images/backgrounds/submit_button.png";


import "./style.css";

export default function ConsentScreen({setGameConsent}) {
  return (
    <>
      <div className="container">
        <span className="company-name">व्यक्तित्व दर्पण खेल</span>
        <p>
        अपने बारे में कुछ नया सीखने के लिए एक तेज़, मज़ेदार गेम के लिए तैयार हैं? 
        <br/> इस बेहद तेज़, मज़ेदार गेम को खेलें! मज़ेदार, सहज चित्रों की एक श्रृंखला में से अपनी पसंद/नापसंद चुनें और कुछ बेहद आसान सवालों के जवाब दें। लीजिए! आपको एक व्यक्तिगत मिनी-रिपोर्ट मिलेगी जो आपके व्यक्तित्व और पसंद की एक झलक देगी! 
        <br/>मज़े करें और खेलना शुरू करें!
        </p>
        <div
          className="continue_button"
          onClick={() => {
            setGameConsent(true);
          }}
        >
          <img src={Button} alt="button_image" className="button_image" />
          <div type="button" className="button_text">
            Continue to Game
          </div>
        </div>
      </div>
    </>
  );
}
